// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1KOX4","field":"styles_field__3C-Uq","textDescription":"styles_textDescription__18v74","loading":"styles_loading__3umcN"};